import { WFHActionsTypes } from './types'

const Types: WFHActionsTypes = {
    DASHBOARD_WFH_DEVICES_ONLINE: {
        request: 'DASHBOARD_WFH_DEVICES_ONLINE##REQUEST',
        success: 'DASHBOARD_WFH_DEVICES_ONLINE##SUCCESS',
        failure: 'DASHBOARD_WFH_DEVICES_ONLINE##FAILURE',
    },
    DASHBOARD_WFH_DWELLTIMELINE: {
        request: 'DASHBOARD_WFH_DWELLTIMELINE##REQUEST',
        success: 'DASHBOARD_WFH_DWELLTIMELINE##SUCCESS',
        failure: 'DASHBOARD_WFH_DWELLTIMELINE##FAILURE',
    },
    DASHBOARD_WFH_INTERACTIONS_PLAYLIST: {
        request: 'DASHBOARD_WFH_INTERACTIONS_PLAYLIST##REQUEST',
        success: 'DASHBOARD_WFH_INTERACTIONS_PLAYLIST##SUCCESS',
        failure: 'DASHBOARD_WFH_INTERACTIONS_PLAYLIST##FAILURE',
    },
    DASHBOARD_WFH_INTERACTIONS_PRODUCT: {
        request: 'DASHBOARD_WFH_INTERACTIONS_PRODUCT##REQUEST',
        success: 'DASHBOARD_WFH_INTERACTIONS_PRODUCT##SUCCESS',
        failure: 'DASHBOARD_WFH_INTERACTIONS_PRODUCT##FAILURE',
    },
    DASHBOARD_WFH_INTERACTIONS_TOTALS: {
        request: 'DASHBOARD_WFH_INTERACTIONS_TOTALS##REQUEST',
        success: 'DASHBOARD_WFH_INTERACTIONS_TOTALS##SUCCESS',
        failure: 'DASHBOARD_WFH_INTERACTIONS_TOTALS##FAILURE',
    },
    DASHBOARD_WFH_PLAYLIST_TOP: {
        request: 'DASHBOARD_WFH_PLAYLIST_TOP##REQUEST',
        success: 'DASHBOARD_WFH_PLAYLIST_TOP##SUCCESS',
        failure: 'DASHBOARD_WFH_PLAYLIST_TOP##FAILURE',
    },
    DASHBOARD_WFH_SESSIONSTIMELINE: {
        request: 'DASHBOARD_WFH_SESSIONSTIMELINE##REQUEST',
        success: 'DASHBOARD_WFH_SESSIONSTIMELINE##SUCCESS',
        failure: 'DASHBOARD_WFH_SESSIONSTIMELINE##FAILURE',
    },
    DASHBOARD_WFH_STORES_TOP: {
        request: 'DASHBOARD_WFH_STORES_TOP##REQUEST',
        success: 'DASHBOARD_WFH_STORES_TOP##SUCCESS',
        failure: 'DASHBOARD_WFH_STORES_TOP##FAILURE',
    },
}

export default Types
